import React from 'react';
import { useNavigate } from 'react-router-dom';
import Preloader from '../components/Preloader';
import NavBar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import FooterAlt from '../Layout/FooterAlt';
import Section from './Section';
const PrivacyPolicy = () => {
    const navigate = useNavigate();
    
    return (
        <React.Fragment>
        <Preloader />
      <NavBar />
      <Section leftSide="Informativa Privacy" />
      <div className='container'>
        <div className="privacy-policy-container row justify-content-center">
        <h1>Privacy Policy</h1>

        <section>
            <p>
            Caro Navigatore, puoi entrare nel sito di tenergia s.r.l. senza essere un utente registrato e accedere alle informazioni, alle notizie e a tutti quei servizi che per essere utilizzati non richiedono l’inserimento di dati personali.
            </p>
        </section>

        <section>
            <h2>Titolare del Trattamento dei Dati</h2>
            <p>
            Tenergia s.r.l – Via Umberto I, N°62 – 04100 Latina, ITALY
            </p>
            <p>
            Indirizzo email del Titolare: <a href="mailto:tenergia2015@gmail.com">tenergia2015@gmail.com</a>
            </p>
        </section>

        <section>
            <h2>Tipologie di Dati raccolti</h2>
            <p>
            Fra i Dati Personali raccolti da questo Sito Web, in modo autonomo o tramite terze parti, ci sono: ragione sociale, cognome, nome, indirizzo, città, CAP, provincia, nazione, email, telefono, username, cookie e dati di utilizzo.
            </p>
            <p>
            Dettagli completi su ciascuna tipologia di dati raccolti sono forniti nelle sezioni dedicate di questa privacy policy o mediante specifici testi informativi visualizzati prima della raccolta dei dati stessi.
            </p>
        </section>

        <section>
            <h2>Modalità e luogo del trattamento dei Dati raccolti</h2>
            <h3>Modalità di trattamento</h3>
            <p>
            Il Titolare adotta le opportune misure di sicurezza volte ad impedire l’accesso, la divulgazione, la modifica o la distruzione non autorizzate dei Dati Personali.
            </p>
            <h3>Luogo del trattamento</h3>
            <p>
            I Dati sono trattati presso le sedi operative del Titolare ed in ogni altro luogo in cui le parti coinvolte nel trattamento siano localizzate. Per ulteriori informazioni, contatta il Titolare.
            </p>
        </section>

        <section>
            <h2>Base giuridica del trattamento</h2>
            <p>
            Il Titolare tratta Dati Personali relativi all’Utente in caso sussista una delle seguenti condizioni:
            </p>
            <ul>
            <li>l’Utente ha prestato il consenso per una o più finalità specifiche;</li>
            <li>il trattamento è necessario all’esecuzione di un contratto con l’Utente;</li>
            <li>il trattamento è necessario per adempiere un obbligo legale;</li>
            <li>il trattamento è necessario per l’esecuzione di un compito di interesse pubblico o per l’esercizio di pubblici poteri;</li>
            <li>il trattamento è necessario per il perseguimento del legittimo interesse del Titolare o di terzi.</li>
            </ul>
        </section>

        <section>
            <h2>Diritti dell’Utente</h2>
            <p>
            Gli Utenti possono esercitare determinati diritti con riferimento ai Dati trattati dal Titolare. In particolare, l’Utente ha il diritto di:
            </p>
            <ul>
            <li>revocare il consenso in ogni momento;</li>
            <li>opporsi al trattamento dei propri Dati;</li>
            <li>accedere ai propri Dati;</li>
            <li>verificare e chiedere la rettificazione;</li>
            <li>ottenere la limitazione del trattamento;</li>
            <li>ottenere la cancellazione o rimozione dei propri Dati Personali;</li>
            <li>ricevere i propri Dati o farli trasferire ad altro titolare;</li>
            <li>proporre reclamo all’autorità di controllo.</li>
            </ul>
        </section>

        <section>
            <h2>Modifiche a questa privacy policy</h2>
            <p>
            Il Titolare del Trattamento si riserva il diritto di apportare modifiche alla presente privacy policy in qualunque momento dandone informazione agli Utenti su questa pagina.
            </p>
        </section>

        <footer>
            <p>Ultimo aggiornamento: Dicembre 2024</p>
        </footer>
        </div>
        </div>
    <Footer />
    <FooterAlt />
    </React.Fragment>
  );
};

export default PrivacyPolicy;
